import { Navigate, useParams } from "react-router-dom";
import { InternalPortal, type InternalPage } from "./InternalPortal";
import "./internal.css";

const pages: InternalPage[] = ["purposes", "data-categories", "processors", "notices", "consents", "user-tickets", "audit", "preview"];

export default function InternalPortalPage() {
  const { page } = useParams();
  if (!page || !pages.includes(page as InternalPage)) {
    return <Navigate to="/internal/purposes" replace />;
  }
  return (
    <div className="internal">
      <InternalPortal page={page as InternalPage} />
    </div>
  );
}
